<form [formGroup]="form" (ngSubmit)="onSubmit(form)" data-testId="prod-form">
  <div class="sidebar__desc" *ngIf="isFailed">Post-processing has failed, please try again.</div>
  <app-processing-settings
    [form]="form"
    [settings]="getSettings()"
    (resetSettings)="restoreDefault()"
  ></app-processing-settings>
  <app-tab-actions [backAction]="onCancel" [isSubmit]="true"></app-tab-actions>
</form>
